/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { cn } from '@/lib/utils';

type AnimatedCheckCircleProps = {
    className?: string;
};

/**
 * Success icon that draws its circle and then its checkmark once on mount,
 * matching the page's thin primary-color line weight.
 */
export function AnimatedCheckCircle({ className }: AnimatedCheckCircleProps) {
    return (
        <svg viewBox="0 0 52 52" fill="none" className={cn('overflow-visible', className)} role="img" aria-label="">
            <circle
                cx="26"
                cy="26"
                r="24"
                className="df-check-circle stroke-primary"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M14 27 L22 35 L38 17"
                className="df-check-mark stroke-primary"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
